import { RichText } from '@graphcommerce/graphcms-ui'
import { Control } from '@graphcommerce/react-hook-form'
import { Box, SxProps, Theme, Typography } from '@mui/material'
import { ConfiguratorSectionFragment } from '../../graphql/configurator/ConfiguratorSection.gql'
import { ConfiguratorQuestion } from './ConfiguratorQuestion'
import { ConfiguratorForm } from './types'

type ConfiguratorSectionProps = {
  configuratorSection: ConfiguratorSectionFragment
  control: Control<ConfiguratorForm>
  sectionIndex: number
  sx?: SxProps<Theme>
}

export function ConfiguratorSection(props: ConfiguratorSectionProps) {
  const { configuratorSection, sectionIndex, control, sx } = props

  if (!configuratorSection) return null

  return (
    <Box sx={[(theme) => ({ mt: theme.spacings.xl }), ...(Array.isArray(sx) ? sx : [sx])]}>
      <Typography variant='h3' color='primary.main'>
        {configuratorSection.title}
      </Typography>
      {configuratorSection.description && (
        <Box sx={(theme) => ({ mt: theme.spacings.xs })}>
          <RichText raw={configuratorSection.description?.raw} />
        </Box>
      )}
      <Box
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: theme.spacings.md,
          mt: theme.spacings.md,
        })}
      >
        {configuratorSection.questions.map((question, index) => (
          <ConfiguratorQuestion
            configuratorQuestion={question}
            key={question.id}
            control={control}
            name={
              question.questionVariant !== 'ageSlider'
                ? `sections.${sectionIndex}.questions.${index}`
                : 'age'
            }
          />
        ))}
      </Box>
    </Box>
  )
}
